import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
    completionId: string;
    courseTitle: string;
    open: boolean;
    onClose: () => void;
}

const CERTIFICATE_HEIGHT = 600;

export const CertificateModal = ({ completionId, courseTitle, onClose, open }: Props) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {t('course.certificate.title', 'Certificate of Completion')} — {courseTitle}
            </DialogTitle>
            <DialogContent sx={{ overflow: 'hidden', p: 0 }}>
                <Box
                    component="iframe"
                    src={`/api/certificate/${completionId}?height=${CERTIFICATE_HEIGHT}`}
                    title={t('course.certificate.iframe_title', 'Certificate of Completion')}
                    sx={{
                        display: 'block',
                        width: '100%',
                        height: CERTIFICATE_HEIGHT,
                        border: 'none',
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    {t('button.close', 'Close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
